/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

function convertDateToUTC(date) {
  var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
  return newDate;
}

function timeConverter(UNIX_timestamp){
  var a = convertDateToUTC(new Date(UNIX_timestamp * 1000));
  var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  //var time = month + " " + ordinal_suffix_of(date) + ", " + year;
  var time = month + " " + date + ", " + year;

  return time;
}

function getShippingDates(variant) {var current_date = Math.floor(Date.now() / 1000);

  var fixed_shipping_date = 0;
  var rolling_shipping_date = 0;
  var rolling_weeks_span = 0;
  var $rolling_date = $("#rolling_shipping_time");
  var $fixed_date = $("#fixed_shipping_time");

  var is_fixed_shipping_display = false;

  // Always expect array of variants
  if(typeof variant.length == "undefined") {
    variant = [variant];
  }

  // Variant dates logic (uses max if more than one)
  $.each(variant, function(index, variant) {
    // Fixed
    if(variant.fixed_date && variant.fixed_date > fixed_shipping_date) {
      fixed_shipping_date = variant.fixed_date;

      if(fixed_shipping_date > current_date) {
        is_fixed_shipping_display = true;
      }
    }

    // Rolling
    if(variant.rolling_date) {
      var rolling = current_date + variant.rolling_date;
      if(rolling_shipping_date < rolling) {
        rolling_shipping_date = rolling;
      }
    }
    if(rolling_shipping_date < current_date) {
      rolling_shipping_date = current_date + ((60*60*24*3)); // Add 3 days to current time
    }

    // Span
    if (variant.rolling_weeks_span > 0 && variant.rolling_weeks_span > rolling_weeks_span) {
      rolling_weeks_span = variant.rolling_weeks_span;
    }
  });


  var converted_fixed = timeConverter(fixed_shipping_date);
  var converted_rolling = timeConverter(rolling_shipping_date)

  if(fixed_shipping_date > current_date || fixed_shipping_date > rolling_shipping_date) {
    converted_rolling = 0;
  }
  else {
    converted_fixed = 0;
  }

  // Update hidden input values
  $fixed_date.val(converted_fixed == "December 31, 1969" ? 0 : converted_fixed);
  $rolling_date.val(converted_rolling);

  return {
    current_date: current_date,
    fixed_shipping_date: fixed_shipping_date,
    rolling_shipping_date: rolling_shipping_date,
    rolling_weeks_span: rolling_weeks_span,
    converted_fixed: converted_fixed,
    converted_rolling: converted_rolling,
    is_fixed_shipping_display: is_fixed_shipping_display
  }
}
function updateShippingDisplay(dates) {var fixed_message = "<p>This product will ship the week of {date}.</p>";
  var rolling_message = "<p>Ships in {date} weeks</p>";
  var formatted_message = '';
  var rolling_weeks_span = dates.rolling_weeks_span > 0 ? dates.rolling_weeks_span : 0;

  var $shipping_display = $(".product-shipping");
  $shipping_display.hide();

  if(dates.is_fixed_shipping_display) {
    var relative_weeks_display = false;
    if (relative_weeks_display) {
      formatted_message = getRelativeWeeksMessage(dates.fixed_shipping_date - dates.current_date, rolling_weeks_span, rolling_message)
    } else {
      formatted_message = fixed_message.replace("{date}", dates.converted_fixed)
    }
  } else {
    formatted_message = getRelativeWeeksMessage(dates.rolling_shipping_date - dates.current_date, rolling_weeks_span, rolling_message)
  }

  if (formatted_message) {
    $shipping_display.html(formatted_message);
    $shipping_display.show();
  }
}

function getRelativeWeeksMessage(delta, weeks_span, message) {
  var minimum_days_to_show = 7;
  var delta_days = Math.floor(delta / 86400);

  if(delta_days >= minimum_days_to_show) {
    var weeks = Math.ceil(delta_days / 7);

    if(weeks == 1) {
      message = message.replace("weeks", "week");
    }

    if (weeks > 1 && weeks_span > 0) {
      return message.replace("{date}", Math.max(weeks - weeks_span, 1) + '-' + weeks)
    }

    return message.replace("{date}", weeks)
  }

  return false
}

/*============================================================================
  Bundling Functions
==============================================================================*/
function BundleAdder() {
  var adding = false;
  var queue = [];

  /**
   * This function takes the same arguments as the /cart/add.js body
   * see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart
   * @param AddToCartPayload
   * @param callback
   */
  function addToCart(payload, callback) {
    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: payload,
      // processData: false,
      success: callback,
      error: function(r) {
        console.error(r);
        callback();
      }
    });
  }

  // Recursive function to flush the queue
  function updateProducts(callback) {
    if (queue.length) {
      addToCart(queue.shift(), function () {
        updateProducts(callback);
      });
    } else {
      callback();
    }
  }

  /**
   * This function takes an array of the addToCart payload defined here
   * see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart
   * @param [AddToCartPayload]
   * @param callback
   */
  return function(products, callback) {
    // Add products to the queue
    if (adding) {
      throw new Error('Unable to add two bundles at once');
    }

    if (products.length == 0) {
      throw new Error('No products to add');
    }

    // We are now adding products
    adding = true;

    // Update the queue
    queue = products;

    updateProducts(function () {
      adding = false;
      $.ajax({
        method: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: callback,
      });
    });
  }
}

ShopifyAPI.orderBundles = function(array, order, key) {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];

    if(order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
};


ShopifyAPI.adjustBundleItems = function(variant_data, quantity, callback) {
  var data = { updates: [] };

  ShopifyAPI.getCart(function(cart) {
    $.each(cart.items, function(index, line_item) {
      var is_bundle_item = false;

      $.each(variant_data, function(index, bundle) {
        if(typeof line_item.properties.bundle_id != "undefined") {
          if(line_item.variant_id == bundle.variant_id && line_item.properties.bundle_id == bundle.bundle_id) {
            data.updates.push(quantity);
            is_bundle_item = true;

            return true;
          }
        }
      });

      if(!is_bundle_item) {
        data.updates.push(line_item.quantity);
      }
    });

    var params = {
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      complete: function(response) {
        if ((typeof callback) === 'function') {
          callback(response.responseJSON)
        }
      }
    };

    $.ajax(params);
  });
};


/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.get('/cart?view=complete', function (cart, textStatus) {
    cart = cart.replace("<!-- BEGIN template --><!-- cart.complete -->", "");
    cart = cart.replace("<!-- END template -->", "");

    var cart = Shopify.ajaxCart = JSON.parse(cart);
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, addToCartText;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    var addToCartText = '';

    // General Selectors
    $body = $('body');

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      var total_items = 0;
      var bundle_list = {};

      $.each(cart.items, function(index, product) {
        if(product.properties && product.properties.bundle_id) {
          bundle_list[product.properties.bundle_id] = bundle_list[product.properties.bundle_id] || []
          bundle_list[product.properties.bundle_id].push(product.quantity);
        } else {
          total_items += product.quantity;
        }
      });

      $.each(bundle_list, function(bundle_id, quantities) {
        total_items += Math.min.apply(null, quantities);
      });

      $cartCountSelector.html(total_items).removeClass('hidden-count');
      $('#CartCountMobile').html(total_items);

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.attr('disabled', 'disabled');
      
        addToCartText = $addToCart.text();
        $addToCart.text('Adding...');
      
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      if($(this).hasClass("bundle-form")) {
        var bundleInstanceId = $(this).data('bundle-instance-id');
        BundleAdder()(section.BundleInstances[bundleInstanceId].getSelectedVariants(), itemAddedCallback);
      } else {
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      }
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeAttr('disabled');
    
      $addToCart.text(addToCartText);
    
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeAttr('disabled');
    
      $addToCart.text(addToCartText);
    
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        bundle_data = {},
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        limit_count = 0,
        show_cart_limit_message = false,
        show_line_limit_message = false;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      if(cartItem.tags.indexOf("#.limit") > -1 || cartItem.tags.indexOf('#.cart-limit') > -1) {
        limit_count += cartItem.quantity;
      }

      if(cartItem.tags.indexOf("#.line-limit") > -1 && cartItem.quantity >= 4) {
        show_line_limit_message = true;
      }

      

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      item = {
        product_id: cartItem.product_id,
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.bundle_only ? "" : cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title == "Default Title" ? "" : cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      if(typeof cartItem.properties.bundle_id != "undefined") {
        var bundle_id = cartItem.properties.bundle_id;
        var parent_id = cartItem.properties.parent_id;

        if(typeof bundle_data[bundle_id] === "undefined") {
          
          bundle_data[bundle_id] = {
            "id": bundle_id,
            "parent_id": parent_id,
            "variation": "",
            "total_items": 0,
            "items": [],
            "title": "",
            "image": "",
            "url": "",
            "items_order": ""
          };
          if (cartItem.parent[parent_id]) {
            bundle_data[bundle_id].title = cartItem.parent[parent_id].title;
            bundle_data[bundle_id].image = cartItem.parent[parent_id].image;
            bundle_data[bundle_id].url = cartItem.parent[parent_id].url;
            bundle_data[bundle_id].items_order = cartItem.parent[parent_id].child_positions;
          }
        }

        if(item.url == "") {
          //item.url = bundle_data[bundle_id].url;
        }
        item.bundle_id = bundle_id;
        bundle_data[bundle_id].total_items += item.itemQty;
        bundle_data[bundle_id]["items"].push(item);

        if(item.variation != "") {
          bundle_data[bundle_id].variation += item.variation + " / ";
        }
      } else {
        items.push(item);
      }
    });

    $.each(bundle_data, function(id, data) {
      ShopifyAPI.orderBundles(data.items, data.items_order, "product_id");

      data["quantity"] = data.total_items / data.items.length;
      data.variation = data.variation.slice(0, -2);
    });

    if(limit_count >= 4) {
      show_cart_limit_message = true;
    }

    // Gather all cart data and add to DOM
    data = {
      show_cart_limit_message: show_cart_limit_message,
      show_line_limit_message: show_line_limit_message,
      parents: bundle_data,
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          id = $el.data('id'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If its a bundle item, update the children.
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if($(this).hasClass("ajaxcart__qty-adjust--bundle")) {
        var variant_ids = [];
        $("[data-parent='"+id+"']").each(function() {
          var variant_id = $(this).data("id");
          variant_ids.push({ "bundle_id": id, "variant_id": variant_id});
        });

        ShopifyAPI.adjustBundleItems(variant_ids, qty, adjustCartCallback);
      }
      else if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // If its a bundle item, update the children.
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          id = $el.data('id'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if($(this).hasClass("ajaxcart__qty-num--bundle")) {
        var variant_ids = [];
        $("[data-parent='"+id+"']").each(function() {
          var variant_id = $(this).data("id");
          variant_ids.push({ "bundle_id": id, "variant_id": variant_id});
        });

        ShopifyAPI.adjustBundleItems(variant_ids, qty, adjustCartCallback);
      }
      else if (line) {
        updateQuantity(line, qty);
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
